import { useState, useEffect } from "react";
import Header from "../Components/Header/Header";
import Parser from 'html-react-parser';
import Carousel from "../Components/Carousel/Carousel";
import StrapiBlocksRenderer from "../Components/StrapiBlocksRenderer/StrapiBlocksRenderer";
import Footer from "../Components/Footer/Footer";
import FinishScreen from "./FinishScreen";
import { useAuthContext } from "../context/AuthContext";
import { API } from "../constant";
import { getToken } from "../helpers";

const Tipps = (props) =>{
    const [start, setStart]=useState(0);
    const [startSlideIndex, setStartSlideIndex] = useState(0);
    const [showFinish, setShowFinish] = useState(false);
    const [isFavorited, setIsFavorited] = useState(false);
    const [favoriteLoading, setFavoriteLoading] = useState(false);

    const { user } = useAuthContext();
    const firstScreen = props.Content.dc[0];
    const steps = props.Content.dc[0].tipps;
    console.log(props.Content);

    // Handle starting the skill - scroll to top and push history state
    const handleStartSkill = () => {
        window.scrollTo(0, 0);
        window.history.pushState({ screen: 'skill' }, '');
        setStart(1);
    };

    // Jump directly to a specific slide (used when direct_navigation is on)
    const handleAbbClick = (index) => {
        setStartSlideIndex(index);
        window.scrollTo(0, 0);
        window.history.pushState({ screen: 'skill' }, '');
        setStart(1);
    };

    // Handle browser back button
    useEffect(() => {
        const handlePopState = (event) => {
            if (start === 1 && !showFinish) {
                // Go back to intro screen
                setStart(0);
                window.scrollTo(0, 0);
            } else if (showFinish) {
                // Go back to carousel from finish
                setShowFinish(false);
                window.scrollTo(0, 0);
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [start, showFinish]);

    // Scroll to top when screen changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [start, showFinish]);

    // Check if skill is already favorited
    useEffect(() => {
        const checkFavoriteStatus = async () => {
            if (!user || !props.SkillId) return;
            try {
                const response = await fetch(`${API}/users/${user.id}?populate=skills`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${getToken()}`,
                    }
                });
                const data = await response.json();
                const isAlreadyFavorited = data.skills?.some(skill => skill.id === props.SkillId);
                setIsFavorited(isAlreadyFavorited);
            } catch (error) {
                console.error("Error checking favorite status:", error);
            }
        };
        checkFavoriteStatus();
    }, [user, props.SkillId]);

    // Handle favorite toggle
    const handleFavorite = async () => {
        if (!user || !props.SkillId) return;
        setFavoriteLoading(true);
        try {
            const skillResponse = await fetch(`${API}/users/${user.id}?populate=skills`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${getToken()}`,
                }
            });
            const responseSkillData = await skillResponse.json();
            let relatedSkills = responseSkillData.skills?.map(item => ({ id: item.id })) || [];

            const existingIndex = relatedSkills.findIndex(item => item.id === props.SkillId);
            if (existingIndex > -1) {
                relatedSkills.splice(existingIndex, 1);
                setIsFavorited(false);
            } else {
                relatedSkills.push({ id: props.SkillId });
                setIsFavorited(true);
            }

            await fetch(`${API}/users/${user.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${getToken()}`,
                },
                body: JSON.stringify({ skills: relatedSkills }),
            });
        } catch (error) {
            console.error("Error updating favorite:", error);
        } finally {
            setFavoriteLoading(false);
        }
    };
 
    console.log(steps);

    const carouselItems= steps.map((item, index)=>{
        const abbreviation = firstScreen.abbreviation?.[index];
        return(
        <div className="carousel-item" data-warning={item.warning}>
            <div className="carousel-item-inner">

                <div className="item-content">
                <h4>{abbreviation ? `${abbreviation.abbr} - ${abbreviation.title}` : props.Content.Title || ''}</h4>
                <h2 className="carousel-item-title">{item.question}</h2>
                <StrapiBlocksRenderer blocks={item.description} />
                <div className="carousel-item-text">
                    <ul className="choose-option-type">
                        {item.question?<li>{item.answer_1}</li>:""}
                        {item.question?<li>{item.answer_2}</li>:""}
                        {item.question?<li>{item.answer_3}</li>:""}
                    </ul>
                </div>
                <div className="correct-answer">
                    <div className="check-icon"></div>
                    <div className="">
                        <h3>Correct!</h3>
                        {item.correct_answer?<p>{item.correct_answer}</p>:""}
                    </div>
                </div>
            </div>
        </div>
    </div>);
    })

    const directNav = !!props.Content.direct_navigation;

    const abbr= firstScreen.abbreviation.map((item, index)=>{
        return(
        <div
            key={index}
            className={`step-item${directNav ? ' step-item-nav' : ''}`}
            onClick={directNav ? () => handleAbbClick(index) : undefined}
            role={directNav ? 'button' : undefined}
            tabIndex={directNav ? 0 : undefined}
            onKeyDown={directNav ? (e) => e.key === 'Enter' && handleAbbClick(index) : undefined}
        >
            <div className="abbr">{item.abbr}</div>
            <div className="right-content">
                <h4>{item.title}</h4>
                <p>{item.short_description}</p>
            </div>
        </div>
        );
    })
   console.log(carouselItems)
    
    const introScreen =
    <div className={`quiz assesment skills ${props.Slug}`} >
        <div className="container">
            <Header  type="primary"/>
            <div className="content-wrap bg-gradient-light">
                <div className="content-wrap-inner">
                <div className="intro-box">
                    <div className="content">
                        {props.Content.Title?<h2>{props.Content.Title}</h2>:""}
                        {props.Content.sub_title?<h4>{props.Content.sub_title}</h4>:""}
                        <StrapiBlocksRenderer blocks={props.Content.description_main} />
                        {abbr?<div className="steps">{abbr}</div>: ""}
                        <button className={`button-right-arrow hover-bounce ${abbr?"":"mt---30"}`} onClick={handleStartSkill}>Start {props.Content.Title} <span className="arrow-right"></span></button>      
                    </div>
                </div>
                </div>
            </div> 
            <Footer /> 
        </div>  
    </div>;

    const mainScreen =
    <div className={`quiz skills-carousel skills ${props.Slug}`} >
        <div className="container">
            <Header  type="primary"/>
            <div className="content-wrap bg-gradient-light">
                <div className="content-wrap-inner">
                <Carousel
                    Items={carouselItems}
                    initialSlide={startSlideIndex}
                    readAloud={!!props.Content.read_aloud}
                    onFinish={() => {
                        window.history.pushState({ screen: 'finish' }, '');
                        setShowFinish(true);
                    }}
                />
                </div>
            </div>
            <Footer />
        </div>
    </div>;

    const finishScreenView = (
        <FinishScreen
            title="Activity is Complete!"
            subtitle={`You've finished the ${props.Content.Title || ''} Skill`}
            message="Excellent work! You've successfully completed the activity."
            buttonText="Back to Activities"
            buttonLink="/ChooseOption"
            className={props.Slug}
            showFavorite={true}
            isFavorited={isFavorited}
            onFavorite={handleFavorite}
            favoriteLoading={favoriteLoading}
        />
    );

    if (showFinish) return finishScreenView;
    return start?mainScreen:introScreen;
}
export default Tipps;